// Utilities for human-friendly display: dates/times and label humanization
const userLocale = (typeof navigator !== 'undefined' && navigator.language) || 'en-GB';

const dateFormatter = new Intl.DateTimeFormat(userLocale, {
  day: '2-digit',
  month: 'short',
  year: 'numeric',
});

const timeFormatter = new Intl.DateTimeFormat(userLocale, {
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
});

const dateTimeFormatter = new Intl.DateTimeFormat(userLocale, {
  day: '2-digit',
  month: 'short',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
});

export function formatDateHuman(value?: string | Date | null): string {
  if (!value) return '-';
  const d = typeof value === 'string' ? new Date(value) : value;
  if (Number.isNaN(d.getTime())) return String(value);
  return dateFormatter.format(d);
}

export function formatTimeHuman(value?: string | Date | null): string {
  if (!value) return '-';
  const d = typeof value === 'string' ? new Date(value) : value;
  if (Number.isNaN(d.getTime())) return String(value);
  return timeFormatter.format(d);
}

export function formatDateTimeHuman(value?: string | Date | null): string {
  if (!value) return '-';
  const d = typeof value === 'string' ? new Date(value) : value;
  if (Number.isNaN(d.getTime())) return String(value);
  return dateTimeFormatter.format(d);
}

export function humanizeLabel(raw?: string | null): string {
  if (raw == null) return '-';
  const s = String(raw).trim();
  if (!s) return '-';
  // If value is all uppercase or all lowercase, convert to Title Case
  if (s.toUpperCase() === s || s.toLowerCase() === s) {
    return s
      .toLowerCase()
      .split(/[_\s-]+/)
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(' ');
  }
  return s;
}
